"use client";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { type SortOrder } from "./list-therapists-search";

const sortOptions = [
  {
    value: "recommended",
    label: "Preporučeni",
  },
  {
    value: "price-asc",
    label: "Cena: najniža",
  },
  {
    value: "price-desc",
    label: "Cena: najviša",
  },
] as const;

export default function SortDropdown({
  onUpdate,
  isPending,
  currentSort,
}: {
  onUpdate: (updates: Record<string, string | undefined>) => void;
  isPending: boolean;
  currentSort: SortOrder;
}) {
  const currentSortLabel =
    sortOptions.find((option) => option.value === currentSort)?.label ??
    "Preporučeni";

  function handleSort(value: string) {
    if (value === currentSort) return;
    onUpdate({ sort: value !== "recommended" ? value : undefined });
  }

  return (
    <Select value={currentSort} onValueChange={handleSort} disabled={isPending}>
      <SelectTrigger className="w-[160px]">
        <SelectValue>{currentSortLabel}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {sortOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
